import ConfirmPasswordInput from './ConfirmPasswordInput';

export default ConfirmPasswordInput;
